import { useState } from 'react';
import { Product } from '../../types/products';
import ProductDetailsView from '../products/ProductDetailsView';
import InventoryCatalog from './InventoryCatalog';

export default function InventoryView() {

  type View = "catalog" | "details";
  const [view, setView] = useState<View>("catalog");
  const [activeProduct, setActiveProduct] = useState<Product | null>(null);
  const [autoOpenStock, setAutoOpenStock] = useState(false);

  const handleSelectProduct = (product: Product) => {
    setActiveProduct(product);
    setView("details");
  }

  const handleBack = () => {
    setActiveProduct(null);
    setView("catalog");
  };

  const handleProductCreated = (product: Product) => {
    setActiveProduct(product);
    setView("details");
    setAutoOpenStock(true);
  };


  const renderView = () => {
    switch(view) {
      case "catalog":
        return (
          <InventoryCatalog
            handleSelectProduct={handleSelectProduct}
            onProductCreated={handleProductCreated}
          />
        );
      case "details":
        return (
          <ProductDetailsView
            activeProduct={activeProduct!}
            onBack={handleBack}
            autoOpenStock={autoOpenStock}
            clearAutoOpen={() => setAutoOpenStock(false)}
          />
        );
    }
  }

  return (
    <>
      {renderView()}
    </>
  );
}
